<template lang="pug">
  .form-component
    component(:is="form" ref="form" :errors="errors" v-bind="$attrs" v-on="$listeners")

    template(v-if="withControls")
      .form-controls.pt-10
        b-button.is-large(type="is-primary" @click="save" :loading="$attrs.value.$state.saving") Сохранить
</template>

<script>
import components from "@/forms";

export default {
  name: "form-component",
  components,
  props: {
    form: String,
    withControls: Boolean,
  },
  data: () => ({
    errors: {},
  }),
  methods: {
    save() {
      this.errors = {};
      let value = this.$attrs.value;
      if (value) {
        let innerForm = this.$refs.form;
        let isCreate = !value.id;
        value
          .$save()
          .then(({ data }) => {
            if (innerForm.afterSave) {
              Promise.resolve(innerForm.afterSave(data)).then(() => {
                this.$emit("afterSave", data);
                if (isCreate) this.$emit("afterCreate", data);
              });
            } else {
              this.$emit("afterSave", data);
              if (isCreate) this.$emit("afterCreate", data);
            }
          })
          .catch(({ validation }) => {
            if (validation) {
              this.errors = validation;
            }
          });
      }
    },
  },
  // created() {
  //   console.log(components);
  // },
};
</script>
